export default {
  Logo: require('./logo.png'),
  TypeformLogo: require('./typeform.png'),
  Paypal: require('./paypal.png')
}
